import { ReactNode } from 'react';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import styles from './StatCard.module.css';

interface StatCardProps {
	label: string;
	value: number | null;
	valueFormatter?: (v: number) => string;
	trendValue?: number | null;
	trendLabel?: string;
	trendDirection?: 'up' | 'down';
	icon: ReactNode;
}

export const StatCard = ({
	label,
	value,
	valueFormatter,
	trendValue,
	trendLabel,
	trendDirection,
	icon,
}: StatCardProps) => {
	const hasValue = value !== null;
	const hasTrend = trendValue !== null && trendValue !== undefined;
	const hasFooter = !hasValue || hasTrend;
	const displayValue = value === null ? '-' : valueFormatter ? valueFormatter(value) : String(value);
	const trendColorClass =
		hasTrend && trendDirection
			? trendDirection === 'up'
				? styles.trendUp
				: styles.trendDown
			: styles.trendNeutral;

	return (
		<div className={styles.card}>
			<div className={styles.content}>
				<div className={styles.textGroup}>
					<span className={`${styles.value} ${!hasValue ? styles.valueEmpty : ''}`}>
						{displayValue}
					</span>
					<span className={styles.label}>{label}</span>
				</div>

				{hasFooter && (
					<div className={styles.footer}>
						{hasTrend && trendDirection === 'up' && (
							<ArrowUpward className={`${styles.trendIcon} ${trendColorClass}`} />
						)}
						{hasTrend && trendDirection === 'down' && (
							<ArrowDownward className={`${styles.trendIcon} ${trendColorClass}`} />
						)}
						<span className={`${styles.trendValue} ${trendColorClass}`}>
							{!hasValue ? 'sem dados' : `${trendValue! > 0 ? '+' : ''}${trendValue}%`}
						</span>
						{hasTrend && trendLabel && <span className={styles.trendLabel}>{trendLabel}</span>}
					</div>
				)}
			</div>

			<div className={styles.iconContainer}>{icon}</div>
		</div>
	);
};
